// Prohodí velikost obrázku v URL (related/big/orig/detail)
// Nové podepsané URL (od 24. 6. 2026, klíč images_with_query_params) mají query parametry
// x/y/q/sg — po úpravě cesty by podpis nebyl validní, proto se z query nechává jen ts=
window.myImageSize = function (url, size) {
    if (!url) {
        return url;
    }

    const parts = url.split("?");
    const base = parts[0].replace(/\/(related|big|orig|detail|category)\//, "/" + size + "/");
    const query = parts[1] || "";

    // Stará URL bez podpisu — query (cache hash) se nechává beze změny
    if (query.indexOf("sg=") === -1) {
        return query ? base + "?" + query : base;
    }

    const ts = query.split("&").filter(function (param) { return param.indexOf("ts=") === 0; })[0];
    return ts ? base + "?" + ts : base;
};

$(document).ready(function () {
    window.myDataLayer = getShoptetDataLayer();
});